import styled from "styled-components"

export interface AttrProps {
}

export const StyledAttrGroup = styled.div`
  margin-top: 8px; 
`

export const StyledAttr = styled.div`
  margin-top: 16px; 
  display: flex;
  align-items: center;

  & i{
    margin-right: 16px;
  }
  & p{
    ${props => props.theme.mixins.bold}
  }
`
